import React from 'react'
import { Card, CardContent, CardHeader } from '@material-ui/core'

export default () => (
  <Card>
    <CardHeader title="Добро пожаловать в статистику." />
    <CardContent>Выберите нужный пункт в меню слева</CardContent>
  </Card>
)
